import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DependencyAffiliateModel, HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { VwCommissionPanelModel } from 'src/app/model/vw-commission-panel.model';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { VwCommissionPanelService } from 'src/oldApp/services/vw-commission-panel.service';

@Component({
  selector: 'app-commission-database',
  templateUrl: './commission-database.component.html',
  styleUrls: ['./commission-database.component.css']
})
export class CommissionDatabaseComponent implements OnInit {
  // estado pagina
  public viewStatus:number=0;
  public page:string='DatabasePanel';
  public commissions:VwCommissionPanelModel[]=[];
  public schemaId:number=0;

  // catalogos
  public schemaCatalog:CatalogModel[]=[];
  public businessLineCatalog:HMGenericCatalog[]=[];
  public anchorTypeCatalog:HMGenericCatalog[]=[];
  public productCatalog:HMGenericCatalog[]=[];
  public paymentCatalog:HMGenericCatalog[]=[];
  public productCategoryCatalog:CatalogModel[]=[];
  public employeeJobCatalog:CatalogModel[]=[];
  public dealerCatalog:DependencyAffiliateModel[]=[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      // { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private schemaService:OtherCatalogsService,
    private vwCommissionPanelService:VwCommissionPanelService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private catProductCategoryService:CatCategoryProductService,
    private catEmployeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  udpateSchema=()=> {
    this.viewStatus=0;
    forkJoin(
      this.vwCommissionPanelService.getBySchema(this.schemaId)
    )
    .pipe(
      tap(([commResp]:[any])=> {
        if(commResp) {
          this.commissions=commResp.data;
          this.viewStatus=1;
        }
        else throwError;  
      }),
      catchError(error=> {
        console.log(error);
        this.commissions=[];
        this.viewStatus=1;
        return of(this.toastr.error('No se encontraron datos.'));
      })
    )
    .subscribe();
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.schemaService.getListSchema(),
      this.hypermatrixCatalogsService.getCatalog('BusinessProductType'),
      this.hypermatrixCatalogsService.getCatalog('OwnerType'),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
      this.hypermatrixCatalogsService.getCatalog('PaymentTermType'),
      this.catProductCategoryService.catalog(),
      this.catEmployeeJobService.catalog(),
      this.hypermatrixCatalogsService.getDependenciasAfiliadoHM()
    )
    .pipe(
      tap(([schemaResp, blResp, ownerResp, prodResp, payResp, prodCatResp, empJobResp, dealerResp]:[any, any, any, any, any, any, any, any])=> {
        if(schemaResp && blResp && ownerResp && prodResp && payResp && prodCatResp && empJobResp && dealerResp) {
          this.schemaCatalog=schemaResp.data;
          this.businessLineCatalog=blResp.data;
          this.anchorTypeCatalog=ownerResp.data;
          this.productCatalog=prodResp.data;
          this.paymentCatalog=payResp.data;
          this.productCategoryCatalog=prodCatResp.data;
          this.employeeJobCatalog=empJobResp;
          this.dealerCatalog=dealerResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
      })
    )
    .subscribe();
  }
}